import React from 'react';

interface StatusBadgeProps {
  status: string;
  attention_needed?: boolean;
}

const getStatusColor = (status: string, isDot: boolean = false) => {
  switch (status.toLowerCase()) {
    case 'draft':
      return isDot ? 'bg-gray-600' : 'text-black';
    case 'approved':
      return isDot ? 'bg-green-501' : 'text-black';
    case 'synced':
      return isDot ? 'bg-blue-500' : 'text-black';
    case 'paid':
      return isDot ? 'bg-purple-500' : 'text-black';
    case 'overdue':
      return isDot ? 'bg-yellow-500' : 'text-black';
    default:
      return isDot ? 'bg-gray-600' : 'text-black';
  }
};

export const StatusBadgeThin: React.FC<StatusBadgeProps> = ({ status, attention_needed = false }) => {
  if (attention_needed) {
    return (
      <span className="inline-flex items-center justify-center py-[1px] px-2 text-[15px] font-bold gap-1 text-red-501">
        <div className="w-2 h-2 rounded-full bg-red-501" />
        Review
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center py-[1px] px-2 text-[13px] font-bold ${getStatusColor(status)} gap-1`}
    >
      <div className={`w-2 h-2 rounded-full ${getStatusColor(status, true)}`} />
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export default StatusBadgeThin;
